import { match, P } from "ts-pattern";
function copy(descriptor, value, context) {
  if (value == null)
    return value;
  return value.map(copyImagesPanelItem);
  function copyImagesPanelItem(imagesPanelItem) {
    const { file } = imagesPanelItem.props;
    if (file == null)
      return imagesPanelItem;
    return {
      ...imagesPanelItem,
      props: {
        ...imagesPanelItem.props,
        file: match([descriptor, file]).with([P.any, P.string], ([, f]) => context.replacementContext.fileIds.get(f) ?? f).with(
          [{ version: 1 }, { type: "makeswift-file", version: 1 }],
          ([, f]) => context.replacementContext.fileIds.get(f.id) ?? f.id
        ).otherwise(([, f]) => f)
      }
    };
  }
}
export {
  copy
};
//# sourceMappingURL=images.js.map